// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__Aa6ta","Hero":"ErrorPage_Hero__OYg3S","SectionTitle":"ErrorPage_SectionTitle__beKdg typography_H2__EDc6d"};